// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__2Vfy7","AuthForm":"Auth_AuthForm__3MPo2"};